import { defineComponent as _defineComponent } from 'vue'
import { storeToRefs } from 'pinia';
import { useConstantStore } from '@/stores/pinia/useConstantStore';
import { useFilterStore } from '@/stores/pinia/useFilterStore';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProvidersButton',
  props: {
    userProvidersOnly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	userProvidersOnly?: boolean;
};



const { providersByShortName } = storeToRefs(useConstantStore());
const filterStore = useFilterStore();
const { selectedProvidersByType } = filterStore;
const { currentFilters, selectedProvidersType } = storeToRefs(filterStore);

const selectedProviders = computed(() => selectedProvidersByType(selectedProvidersType.value ?? undefined));

const providers = computed(() => {
	if (props.userProvidersOnly) {
		return selectedProvidersByType('my_services');
	}

	if (currentFilters.value.providers.length) {
		return currentFilters.value.providers.map(shortName => providersByShortName.value[shortName]);
	}

	return selectedProviders.value;
});

const providersToDisplay = computed(() => providers.value.slice(0, 5));

const selectedProvidersCount = computed(() => {
	const filteredProvidersCount = currentFilters.value.providers.length;

	if (filteredProvidersCount && !props.userProvidersOnly) {
		return `${filteredProvidersCount}/${selectedProviders.value.length}`;
	}

	return providers.value.length;
});

const isActive = computed(() => selectedProvidersType.value !== 'all' || currentFilters.value.providers.length > 0);

return { __sfc: true,props, providersByShortName, filterStore, selectedProvidersByType, currentFilters, selectedProvidersType, selectedProviders, providers, providersToDisplay, selectedProvidersCount, isActive, ProviderIcon }
}

})